export default "__VITE_ASSET__CgJXBWIW__"